const LOCAL_STORAGE_KEY = 'article_organizer_cards';

const safeLocalStorageAction = (localStorageAction) => {
    try {
        if (global.window && localStorage && localStorageAction) {
            localStorageAction();
        }
    } catch (error) {
        // in production, we silently fail and drop the history feature
        if (process.env.NODE_ENV === 'development') {
            throw error;
        }
    }
};

/**
 * Stores in localStorage the last visited card and its index.
 * @param {string} bucketKey
 * @param {string} lastVisitedCardKey
 * @param {integer} lastVisitedCardIndex
 */
export const storeLastVisitedCard = ({
    bucketKey,
    lastVisitedCardKey,
    lastVisitedCardIndex,
}) => {
    safeLocalStorageAction(() => {
        const bucketLastVisitedKey = {
            [`${bucketKey}`]: {
                cardKey: lastVisitedCardKey,
                index: lastVisitedCardIndex,
            },
        };

        const lastVisitedCards = localStorage.getItem(LOCAL_STORAGE_KEY);
        const parsedLastVisitedCards = {
            ...JSON.parse(lastVisitedCards),
            ...bucketLastVisitedKey,
        };

        localStorage.setItem(
            LOCAL_STORAGE_KEY,
            JSON.stringify(parsedLastVisitedCards),
        );
    });
};

/**
 * Returns the last visited organizer article card stored in a certain bucket.
 * @param {string} bucketKey
 * Returns:
 * * {cardKey (string), index (integer)}
 */
export const retrieveLastVisitedCard = ({ bucketKey }) => {
    let lastVisitedCards;

    safeLocalStorageAction(() => {
        lastVisitedCards = localStorage.getItem(LOCAL_STORAGE_KEY);
    });

    if (lastVisitedCards) {
        lastVisitedCards = JSON.parse(lastVisitedCards)[bucketKey];
    } else {
        lastVisitedCards = { index: 0 };
    }

    return lastVisitedCards;
};
